// extracted by mini-css-extract-plugin
export default {"page":"zO","headerwrap":"AO","headerblock":"BO","textwrapper":"CO","text":"EO","closerlook":"FO","arrowwrap":"GO","icon":"HO","updown":"IO","products":"JO","system":"KO","systemimage":"LO","cards":"MO","note":"NO","fadein":"OO"};
    if(module.hot) {
      // 1713969935614
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  